import useUserSubsidiariesProvider from './useUserSubsidiariesProvider';
import { useTimerProvider } from './timerProvider';

export default function Providers() {
  useUserSubsidiariesProvider();
  useTimerProvider();
  return null;
}
